var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_vm._l((_vm.counts),function(ref,index){
var label = ref.label;
var colorOption = ref.colorOption;
var icon = ref.icon;
var count = ref.count;
return [_c('v-col',{key:("col-" + index)},[_c('psi-stats-card',{attrs:{"hide-actions":"","title":label,"stat":count,"color-option":colorOption,"icon":icon}})],1)]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }